module.exports = __webpack_public_path__ + "static/varicent-logo-3ee7c99bbab45941ba7d7e63532ec2d2.png";